export const analyticsApi = (client) => ({
    search: (q) => client.get('/api/v1/analytics/search', { params: { q } }).then((r) => r.data),
    dashboard: (days) => client.get('/api/v1/analytics/dashboard', { params: days ? { days } : undefined }).then((r) => r.data),
    /// Detailed compliance dashboard — checklist + WO completion view
    /// powering the "Detailed Overview" section of the web Overview page.
    dashboardDetailed: (params) => {
        // Flatten tag_ids to a CSV string — Axios's default array
        // serialiser produces `tag_ids[]=a&tag_ids[]=b` which the
        // controller doesn't parse. Everything else passes through.
        const { tag_ids, ...rest } = params ?? {};
        const query = { ...rest };
        if (tag_ids && tag_ids.length > 0)
            query.tag_ids = tag_ids.join(',');
        return client.get('/api/v1/analytics/dashboard-detailed', { params: query }).then((r) => r.data);
    },
    /// Personal, gamified performance bundle for the My Overview tab.
    /// Always returns data for the calling user — no `user_id` needed.
    myPerformance: (params) => client.get('/api/v1/analytics/my-performance', { params }).then((r) => r.data),
    /// Per-site overview bundle for the interactive Overview map.
    /// 403 if the caller lacks `overview:read_map`; 404 if the site
    /// isn't accessible under the active customer scope.
    siteOverview: (siteId) => client.get(`/api/v1/analytics/site-overview/${siteId}`)
        .then((r) => r.data),
    auditLogs: (params) => client.get('/api/v1/analytics/audit-logs', { params }).then((r) => r.data),
    auditReportHtml: (module) => client.get('/api/v1/analytics/audit-report', { params: { module }, responseType: 'text', transformResponse: [(d) => d] }).then((r) => r.data),
});
//# sourceMappingURL=analytics.js.map